import { render, staticRenderFns } from "./ModalCommentsHistory.vue?vue&type=template&id=e91cb47a&scoped=true"
import script from "./ModalCommentsHistory.vue?vue&type=script&lang=js"
export * from "./ModalCommentsHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalCommentsHistory.vue?vue&type=style&index=0&id=e91cb47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91cb47a",
  null
  
)

export default component.exports